import React from "react";
import { compose, withActions } from "containers/HOC";
import * as utils from "common/utils";
import SortableTable from "components/new/SortableTable";
import SortableTableHeader from "components/new/SortableTableHeader";
import ActionLink from "components/ActionLink";
import { modal, confirm } from "containers/App/_actions";
import { deleteUserInvitation } from "./_actions";

const UserInvitationList = ({ userInvitations, showCount = false, modal, confirm, deleteUserInvitation }) => {
    const resendInvitation = (invitation) => (e) => {
        const viewModel = {
            invitation,
        };
        modal("InviteUserModal", null, viewModel);
    };

    const deleteInvitation = (invitation) => (e) => {
        confirm(`Are you sure you want to delete the invitation to "${invitation.email}"?`, () => deleteUserInvitation(invitation), false);
    };

    return (
        <React.Fragment>
            {showCount && (
                <p className="u-mt-0 u-mb-md">
                    <span className="h3">{userInvitations.length}</span> invitation(s)
                </p>
            )}
            <SortableTable data={userInvitations} defaultSortCriteria={{ fieldName: "email" }}>
                {({ data, sortCriteria, handleSort }) => {
                    return (
                        <table>
                            <thead>
                                <tr>
                                    <SortableTableHeader label="Email" fieldName="email" sortCriteria={sortCriteria} handleSort={handleSort} />
                                    <SortableTableHeader label="Sent" fieldName="invitedOn" sortCriteria={sortCriteria} handleSort={handleSort} date />
                                    <SortableTableHeader label="Completed" fieldName="completedOn" sortCriteria={sortCriteria} handleSort={handleSort} date />
                                    <SortableTableHeader label="Status" fieldName="status" sortCriteria={sortCriteria} handleSort={handleSort} />
                                    <th className="th--shrink"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((invitation) => {
                                    return (
                                        <tr key={invitation.id} id={invitation.id} className="hover">
                                            <td>{invitation.email}</td>
                                            <td>{utils.dateLong(invitation.invitedOn, "-")}</td>
                                            <td>{utils.dateLong(invitation.completedOn, "-")}</td>
                                            <td>{invitation.status}</td>
                                            <td>
                                                <div className="u-flex">
                                                    <ActionLink id={`resend-${invitation.id}`} className="IconLink--edit" onClick={resendInvitation(invitation)}>
                                                        Resend
                                                    </ActionLink>
                                                    <ActionLink id={`delete-${invitation.id}`} className="IconLink--cross-circle u-ml-sm" onClick={deleteInvitation(invitation)}>
                                                        Delete
                                                    </ActionLink>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    );
                }}
            </SortableTable>
        </React.Fragment>
    );
};

export default compose(withActions({ modal, confirm, deleteUserInvitation }))(UserInvitationList);
